<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_reward_action } from '@/services/reward_actions';
import { create_reward_history } from '@/services/reward_histories';
import { onMounted, ref } from 'vue';

const props = defineProps({
  child_id: {
    required: true
  }
})

const isLoading = ref(true)
const reward = ref({
  point_value: 0,
  description: ''
})
onMounted(async()=>{
  await retrieve_reward_value()
  isLoading.value = false
})

const reward_action = ref({})
async function retrieve_reward_value(){
  let response = await get_reward_action('manual_reward')
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_action.value = response.result.data.data
  reward.value.point_value = response.result.data.data.attributes.point_value
}

async function submitReward(){
  let params = {
    ...reward.value,
    reward_action_id: reward_action.value.id,
    child_id: props.child_id
  }
  let response = await create_reward_history(params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Reward has been given')
  reward.value = {
    point_value: 0,
    description: ''
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <h5 class="m-0">Manual Reward Option</h5>
    </div>
    <div class="card-body pt-0">
      <form @submit.prevent="submitReward()">
        <div class="row mb-2">
          <div class="d-flex align-items-center">
            <p class="mb-0">Reward Description : </p>
            <input type="text" 
              class="form-control" 
              v-model="reward.description"
              placeholder="Reward Description"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-3 d-flex align-items-center">
            <p>Point Value : </p>
          </div>
          <div class="col-5">
            <input type="number" 
              class="form-control" 
              v-model="reward.point_value"
              placeholder="Point Value"
            >
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-light-success">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>